import {
  type NifsFullMatch,
  type NifsMatchDetail,
  NifsMatchDetailSchema,
} from '@pin/schemas/nifs';
import {
  type Question,
  QuestionSchema,
  type Solution,
  SolutionSchema,
} from '@pin/schemas/quiz';
import {
  type Round,
  RoundSchema,
  type Tournament,
  TournamentSchema,
} from '@pin/schemas/tournament';
import { type FirestoreDataConverter } from 'firebase/firestore';
import * as z from 'zod';

export const tournamentConverter: FirestoreDataConverter<Tournament> = {
  toFirestore: () => {
    throw new Error('Admin should use admin-api to write to firestore.');
  },
  fromFirestore: (snapshot, options?) => {
    const data = snapshot.data(options);
    const result = TournamentSchema.safeParse(data);
    if (result.success) {
      return result.data;
    } else {
      throw new Error(z.prettifyError(result.error));
    }
  },
};

export const roundConverter: FirestoreDataConverter<Round> = {
  toFirestore: () => {
    throw new Error('Admin should use admin-api to write to firestore.');
  },
  fromFirestore: (snapshot, options?) => {
    const data = snapshot.data(options);
    const result = RoundSchema.safeParse(data);
    if (result.success) {
      return result.data;
    } else {
      throw new Error(z.prettifyError(result.error));
    }
  },
};

export const questionConverter: FirestoreDataConverter<Question> = {
  toFirestore: () => {
    throw new Error('Admin should use admin-api to write to firestore.');
  },
  fromFirestore: (snapshot, options?) => {
    const data = snapshot.data(options);
    const result = QuestionSchema.safeParse(data);
    if (result.success) {
      return result.data;
    } else {
      throw new Error(z.prettifyError(result.error));
    }
  },
};

export const nifsMatchDetailConverter: FirestoreDataConverter<
  NifsMatchDetail,
  NifsFullMatch
> = {
  toFirestore: () => {
    throw new Error('Admin should use admin-api to write to firestore.');
  },
  fromFirestore: (snapshot, options?) => {
    const data = snapshot.data(options);
    const result = NifsMatchDetailSchema.safeParse(data);
    if (result.success) {
      return result.data;
    } else {
      throw new Error(z.prettifyError(result.error));
    }
  },
};

export const solutionConverter: FirestoreDataConverter<Solution> = {
  toFirestore: () => {
    throw new Error('Admin should use admin-api to write to firestore.');
  },
  fromFirestore: (snapshot, options?) => {
    const data = snapshot.data(options);
    const result = SolutionSchema.safeParse(data);
    if (result.success) {
      return result.data;
    } else {
      throw new Error(z.prettifyError(result.error));
    }
  },
};
